import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { Stat, Section, Loading, Empty, useFetch, money, dt } from "./_shared";

export default function Ads() {
  const { data: queue, loading, reload } = useFetch("/admin/ads/queue");
  const { data: ov } = useFetch("/admin/ads/overview");
  const [busy, setBusy] = useState(null);
  if (loading) return <Loading />;
  const cp = queue?.campaigns_pending || []; const op = queue?.offerings_pending || [];
  const counts = ov?.counts || {};

  const campAction = async (id, action) => {
    setBusy(id);
    try { await api.post(`/admin/ads/campaigns/${id}/${action}`, action === "reject" ? { note: "Nicht konform" } : {}); await reload(); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(null); }
  };
  const offAction = async (id, action) => {
    setBusy(id);
    try { await api.post(`/admin/ads/offerings/${id}/${action}`, action === "reject" ? { note: "Nicht konform" } : {}); await reload(); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(null); }
  };

  return (
    <div className="space-y-5">
      <PageHeader eyebrow="Admin" title="Werbung" subtitle="Kampagnen & Angebote moderieren." />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label="Kampagnen offen" value={cp.length} tone={cp.length ? "warn" : "good"} testId="admin-ads-pending-campaigns" />
        <Stat label="Angebote offen" value={op.length} tone={op.length ? "warn" : "good"} testId="admin-ads-pending-offerings" />
        <Stat label="Modus" value={queue?.mode || "—"} />
        <Stat label="Aktiv gesamt" value={counts.active ?? counts.total ?? "—"} />
      </div>

      <Section title={`Kampagnen zur Prüfung (${cp.length})`} testId="admin-ads-campaigns">
        {cp.length === 0 ? <Empty text="Keine offenen Kampagnen." /> : (
          <div className="space-y-2">
            {cp.map((c) => (
              <div key={c.id} className="flex items-start justify-between gap-3 rounded-xl border border-border bg-background p-3">
                <div className="min-w-0"><p className="truncate text-sm font-medium text-foreground">{c.title || c.id}</p><p className="truncate text-xs text-muted-foreground">{c.budget ? money(c.budget) : ""}{c.created_at ? ` · ${dt(c.created_at)}` : ""}</p></div>
                <div className="flex gap-1.5">
                  <Button size="sm" variant="outline" className="rounded-full text-emerald-600" disabled={busy === c.id} onClick={() => campAction(c.id, "approve")} data-testid={`admin-ads-approve-camp-${c.id}`}><Check className="h-4 w-4" /></Button>
                  <Button size="sm" variant="outline" className="rounded-full text-rose-600" disabled={busy === c.id} onClick={() => campAction(c.id, "reject")} data-testid={`admin-ads-reject-camp-${c.id}`}><X className="h-4 w-4" /></Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Section>

      <Section title={`Angebote zur Prüfung (${op.length})`} testId="admin-ads-offerings">
        {op.length === 0 ? <Empty text="Keine offenen Angebote." /> : (
          <div className="space-y-2">
            {op.map((o) => (
              <div key={o.id} className="flex items-start justify-between gap-3 rounded-xl border border-border bg-background p-3">
                <div className="min-w-0"><p className="truncate text-sm font-medium text-foreground">{o.title || o.id}</p><p className="truncate text-xs text-muted-foreground">{o.price_cents ? money(o.price_cents) : ""}</p></div>
                <div className="flex gap-1.5">
                  <Button size="sm" variant="outline" className="rounded-full text-emerald-600" disabled={busy === o.id} onClick={() => offAction(o.id, "approve")} data-testid={`admin-ads-approve-off-${o.id}`}><Check className="h-4 w-4" /></Button>
                  <Button size="sm" variant="outline" className="rounded-full text-rose-600" disabled={busy === o.id} onClick={() => offAction(o.id, "reject")} data-testid={`admin-ads-reject-off-${o.id}`}><X className="h-4 w-4" /></Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
